// extracted by mini-css-extract-plugin
module.exports = {"root":"R_bj","icon":"R_br","main-search-icon":"R_cV","mainSearchIcon":"R_cV","label-icon-default-filled":"R_cW","labelIconDefaultFilled":"R_cW"};